import React from "react";

export const ArrowUp = () => {
    return (
        <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.39409 5.43678C0.0561361 5.76222 0.0561361 6.28986 0.39409 6.6153C0.732044 6.94073 1.27998 6.94073 1.61793 6.6153L4.98438 3.37353L4.98437 15.6094C4.98437 16.0408 5.33415 16.3906 5.76562 16.3906C6.1971 16.3906 6.54687 16.0408 6.54687 15.6094L6.54688 3.37353L9.91332 6.6153C10.2513 6.94073 10.7992 6.94073 11.1372 6.6153C11.4751 6.28986 11.4751 5.76222 11.1372 5.43678L6.37754 0.853451C6.03959 0.528015 5.49166 0.528015 5.15371 0.853452L0.39409 5.43678Z" fill="currentColor" />
        </svg>

    )
}